module.exports = "/packs/015-332d426bf9a61ea45c5950a02a748e6e.jpg";